import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-1 mt-[149px]" }
const _hoisted_2 = { class: "mx-auto max-w-[1326px] mt-10 mb-[76px]" }
const _hoisted_3 = { class: "flex gap-x-[112px]" }
const _hoisted_4 = { class: "flex flex-col gap-y-[76px]" }
const _hoisted_5 = { class: "max-w-[1326px] mx-auto w-full px-[120px] mb-[104px] mt-[-120px]" }
const _hoisted_6 = { class: "px-3 mb-[40px]" }
const _hoisted_7 = { class: "p-[10px] text-[22px] mb-[54px]" }
const _hoisted_8 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Загрузка...", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "mb-[54px]" }
const _hoisted_12 = { class: "px-3 mb-[40px]" }
const _hoisted_13 = { class: "mb-[54px]" }
const _hoisted_14 = { class: "px-3 mb-[40px]" }
const _hoisted_15 = { class: "pl-5 mt-4" }
const _hoisted_16 = { class: "list-disc pl-10 mt-4" }
const _hoisted_17 = { class: "pl-5 mt-4" }
const _hoisted_18 = { class: "mb-6" }
const _hoisted_19 = { class: "pl-5 mt-4" }
const _hoisted_20 = { class: "mb-6" }

import { ref } from 'vue';
import BaseAccordion from '@/components/common/BaseAccordion.vue';
import ReturnButton from '@/components/common/ReturnButton.vue';
import Photo from './Photo.vue';
import Reservation from './Reservation.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import MarkdownRenderer from '@/components/common/MarkdownRenderer.vue';
import Form from './Form.vue';
import { useGlobalStore } from '@/stores/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExcursionDesktop',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const globalStore = useGlobalStore();
const { getExcursion } = globalStore;

const excursion = ref<any>();
const isLoading = ref<boolean>(true);

const goToForm = () => {
    const element = document.getElementById('form');
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};

const onLoad = async () => {
    isLoading.value = true;
    excursion.value = await getExcursion(props.id);
    isLoading.value = false;
};

onLoad();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ReturnButton, {
            text: excursion.value?.data.attributes?.title
          }, null, 8, ["text"]),
          _createVNode(Photo, { excursion: excursion.value }, null, 8, ["excursion"])
        ]),
        _createVNode(Reservation, {
          excursion: excursion.value,
          onClick: goToForm
        }, null, 8, ["excursion"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseTypography, {
          text: "Описание",
          type: "subtitle"
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : (_openBlock(), _createBlock(MarkdownRenderer, {
              key: 1,
              markdown: excursion.value?.data.attributes?.description
            }, null, 8, ["markdown"]))
      ]),
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseTypography, {
            text: "Что включено",
            type: "subtitle"
          })
        ]),
        _createVNode(BaseAccordion, {
          title: "Экскурсионное обслуживание",
          class: "mb-[30px]",
          disabled: ""
        }),
        _createVNode(BaseAccordion, {
          title: "Входные билеты",
          disabled: ""
        })
      ]),
      _createVNode(Form, { id: "form" }),
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(BaseTypography, {
            text: "Часто задаваемые вопросы",
            type: "subtitle"
          })
        ]),
        _createVNode(BaseAccordion, {
          title: "Как забронировать и оплатить",
          class: "mb-[30px]"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(BaseTypography, {
                text: "Шаг 1: отправить заявку",
                type: "body2",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "Забронировать места на экскурсию вы можете следующим образом:",
                type: "body",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "- нажать кнопку «ЗАБРОНИРОВАТЬ» в описании экскурсии;",
                type: "body"
              }),
              _createVNode(BaseTypography, {
                text: "- написать на почтовый адрес reserv@rvm-spb.ru;",
                type: "body"
              }),
              _createVNode(BaseTypography, {
                text: "- отправить запрос по электронной почте info@rvm-spb.ru.",
                type: "body",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "Шаг 2: оплатить билеты",
                type: "body2",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "У вас есть 2 способа сделать это:",
                type: "body",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "1) Удалённо, через различные системы оплат (расчет с использованием реквизитов банковской карты, переводом через интернет-банк).",
                type: "body"
              }),
              _createVNode(BaseTypography, {
                text: "2) Подъехать заранее к нам в офис и оплатить наличными или по картам VISA, Mastercard, МИР. Наш офис в Бизнес центре 'Петровский форт', Финляндский проспект 4А, офис 201",
                type: "body",
                class: "mb-6"
              }),
              _createElementVNode("div", null, [
                _createVNode(BaseTypography, {
                  text: "Внимание! ",
                  type: "body2",
                  tag: "span"
                }),
                _createVNode(BaseTypography, {
                  text: "Наличие мест на экскурсию подтверждается только специалистом компании. На все предложения туроператора действует правило предварительной оплаты в течение 3-5 дней с момента бронирования в зависимости от даты начала экскурсии. Уточняйте у специалистов.",
                  type: "body",
                  tag: "span"
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(BaseAccordion, {
          title: "Способ оплаты",
          class: "mb-[30px]"
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_16, [
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "Visa",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "MasterCard",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "Сбербанк",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "ВТБ",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "Тинькофф",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "Наличными",
                  type: "body"
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(BaseAccordion, {
          title: "Сроки оплаты экскурсии",
          class: "mb-[30px]"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(BaseTypography, {
                  text: "Бронирование экскурсии должно быть оплачено ",
                  type: "body",
                  tag: "span"
                }),
                _createVNode(BaseTypography, {
                  text: "не позднее чем за 3 дня до ее проведения.",
                  type: "body",
                  tag: "span"
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(BaseTypography, {
                  text: "! ",
                  type: "body2",
                  tag: "span"
                }),
                _createVNode(BaseTypography, {
                  text: "Наш специалист отправит вам напоминание о крайнем сроке оплаты бронирования.",
                  type: "body",
                  tag: "span"
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(BaseAccordion, {
          title: "Условия отмены бронирования",
          class: "mb-[30px]"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(BaseTypography, {
                  text: "Отмена бронирования экскурсии осуществляется ",
                  type: "body",
                  tag: "span"
                }),
                _createVNode(BaseTypography, {
                  text: "не позднее чем за 7 дня до ее проведения.",
                  type: "body",
                  tag: "span"
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(BaseTypography, {
                  text: "! ",
                  type: "body2",
                  tag: "span"
                }),
                _createVNode(BaseTypography, {
                  text: "Сроки аннуляций и штрафы по сборным экскурсиям определяются индивидуально и будут прописаны в договоре. Размер штрафа равняется фактически понесенным затратам. В случае частичной аннуляции услуг указанные штрафные санкции применяются к стоимости аннулированной части услуг.",
                  type: "body",
                  tag: "span"
                })
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})